module.exports = __webpack_public_path__ + "img/Aon.9dd5b032.jpg";